/* eslint-disable react/prop-types */
import React from 'react';
import { Card as CardWrapper, CardHeader, CardBody, UncontrolledTooltip } from 'reactstrap';
import { withTranslation } from 'react-i18next';

const generateSafeId = (text) =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '-')
    .toLowerCase();

const KpiCard = ({ t, title, value, suffix, icon, tooltip }) => {
  const tooltipId = generateSafeId(`tooltip-${title}`);

  return (
    <CardWrapper className="card-summary h-100">
      <CardHeader className="py-2">
        <div className="card-responsive d-flex align-items-center justify-content-between">
          <h6 className="m-0 text-uppercase" style={{ fontSize: '0.7rem' }}>
            {title}
            <i
              className="bx ri-question-line align-middle ms-2"
              id={tooltipId}
            ></i>
            <UncontrolledTooltip target={tooltipId}>
              {tooltip}
            </UncontrolledTooltip>
          </h6>
        </div>
      </CardHeader>
      <CardBody className="py-2">
        <div className="d-flex align-items-center" style={{ minHeight: '60px' }}>
          {/* LEFT half: value + suffix */}
          <div className="flex-grow-1">
            <h2 className="fw-bold mb-0" style={{ fontSize: '1.4rem', lineHeight: 1.2 }}>
              {value}
            </h2>
            {suffix && (
              <h6 className="fs-7 ff-secondary mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                {suffix}
              </h6>
            )}
          </div>
          {/* RIGHT half: icon centered */}
          <div className="flex-shrink-0 text-center" style={{ width: '60px' }}>
            <i className={`${icon}`} style={{ fontSize: '2rem', opacity: 0.7 }}></i>
          </div>
        </div>
      </CardBody>
    </CardWrapper>
  );
};

export default withTranslation()(KpiCard);
